import { useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

export function useExpenseCancel() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, reason }) =>
      api.post(`/finance/expenses/${id}/cancel`, { reason }).then((r) => r.data),
    successMessage: 'تم إلغاء المصروف',
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['finance', 'expenses'] });
      qc.invalidateQueries({ queryKey: ['finance', 'stats'] });
      qc.invalidateQueries({ queryKey: ['cashbox'] });
    }
  });
}
